import React, { Component } from "react";
import Login from "../UI/Login";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as userActions from "../../_actions/userActions";
import Wrapper from "../../_hoc/Wrapper";
import isUserLoggedIn from "../../_selectors/userSelectors/isUserLoggedIn";
import getInitialUrl from "../../_selectors/userSelectors/getInitialUrl";
import ToastContainer from "../Layout/ToastContainer";
class LoginPage extends Component {
  state = { showLogin: true };
  _createNewAccount = credential => {
    const { signUp } = this.props;
    const onSuccess = user => {
      console.log(user);
      this.setState({ showLogin: true });
    };
    const onError = error => {
      console.log(error);
    };
    signUp({ ...credential, ...{ onSuccess, onError } });
  };
  render() {
    const { login, signUp, isLoggedIn, url, forgotPassword } = this.props;
    let redirect = isLoggedIn ? (
      url === "/login" ? (
        <Redirect to="/" />
      ) : (
        <Redirect to={url} />
      )
    ) : null;
    return (
      <Wrapper>
        {redirect}
        <Login
          onLogin={formData => {
            login(formData);
          }}
          onCreateAccount={signUp}
          showLogin={true}
          onForgotPassword={forgotPassword}
        />
        <ToastContainer />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isLoggedIn: isUserLoggedIn(state),
  url: getInitialUrl(state)
});

const mapDispatchToProps = dispatch => {
  return {
    login: payload => dispatch(userActions.authenticateUser(payload)),
    signUp: payload => dispatch(userActions.createAccount(payload)),
    forgotPassword: payload => dispatch(userActions.forgotPassword(payload))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage);



// WEBPACK FOOTER //
// ./src/_components/LoginPage/index.js